module.exports = __webpack_public_path__ + "media/images/sp/plans/search_form/location_type_resort_sola@2x-3615996b5daa014bcadf51e7b7de081f.webp";